import Const from 'Utils/Consts'

const CommonApiPaths = {
  Translation: {
    GetAll: `digital_software_management/api/ParrotTranslation/GetAll?SoftwareCode=${Const.env.REACT_APP_REACT_SOFT_WARE_CODE}`,
    GetAllJson: `digital_software_management/api/ParrotTranslation/GetAllJson?SoftwareCode=${Const.env.REACT_APP_REACT_SOFT_WARE_CODE}`,
  },
  Expert: {
    GetInsuranceExpertFieldsCurrentUser:
      'registration_issurance_visit/api/Expert/GetInsuranceExpertFieldsCurrentUser',
    SetSsoData: 'registration_issurance_visit/api/Expert/SetSsoData',
  },
  HealthCheck: 'registration_issurance_visit/health',
  settings: {
    GetAllSettings: `digital_software_management/api/DipConfiguration/GetConfigsByAppKey?ApplicationKey=${Const.env.REACT_APP_APPLICATION_KEY}`,
  },
  users: {
    GetUserAccessList: `digital_software_management/api/DipUserRole/GetAllUserSoftwarePartsForPod?SoftwareCode=${Const.env.REACT_APP_REACT_SOFT_WARE_CODE}`,
  },
}
export default CommonApiPaths
